// eslint-disable-next-line no-restricted-imports -- Intended
import {defaultTo, find, map, pathOr, pipe} from 'ramda';

import {useGetTenantQuery, useGetVatRatesQuery} from '@dms/api/core';
import {VatRate} from '@dms/api/shared';

import {Nullish} from 'shared/web';

type VatRateOption = {
  value: string;
  label: string;
  fieldLabel?: string;
  rate: string;
  type: string;
};

interface UseGetVatRatesOptionsProps {
  fullLabel?: boolean;
}

export function useGetVatRatesOptions(props?: UseGetVatRatesOptionsProps) {
  const {data: tenant} = useGetTenantQuery();
  const {vatOptions} = useGetVatRatesQuery(undefined, {
    selectFromResult: ({data}) => ({
      vatOptions: pipe<
        [VatRate[] | Nullish],
        VatRate[],
        VatRate | undefined,
        VatRate['rates'],
        VatRateOption[]
      >(
        defaultTo([]),
        find<VatRate>(({code}) => code === tenant?.country),
        pathOr([], ['rates']),
        map((vatRate) => ({
          value: vatRate.type,
          label: `${vatRate.rate} % ${vatRate.name}`,
          fieldLabel: !props?.fullLabel ? `${vatRate.rate} %` : undefined,
          rate: vatRate.rate,
          type: vatRate.type,
        }))
      )(data),
    }),
  });
  return [vatOptions];
}
